import { render, staticRenderFns } from "./PlataformasEstudiantes.vue?vue&type=template&id=0f14ca8a&scoped=true"
import script from "./PlataformasEstudiantes.vue?vue&type=script&lang=js"
export * from "./PlataformasEstudiantes.vue?vue&type=script&lang=js"
import style0 from "./PlataformasEstudiantes.vue?vue&type=style&index=0&id=0f14ca8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14ca8a",
  null
  
)

export default component.exports